<template>
  <VueResizable class="edit-help-catalog" :active="['l']" width="252px" height="100%">
    <ul>
      <li v-for="(item, index) in toc" :key="item.id" :type="item.type" :class="{'active': activeIndex === index, [item.type]: true}" @click="selectIndex(index)">
        <toolTip :title="item.text" style="width: 100%;">{{item.text}}</toolTip>
      </li>
    </ul>
  </VueResizable>
</template>
<script>
import VueResizable from 'vue-resizable'
export default {
  props: {
    toc: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number,
      default: -1
    }
  },
  components: {
    VueResizable
  },
  data() {
    return {

    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  },
  methods: {
    selectIndex(index) {
      this.$emit('select', index)
    }
  }
}
</script>
<style lang="scss">
.edit-help-catalog {
  overflow-x: hidden;
  flex-shrink: 0;
  left: 0 !important;
  border-left: 1px solid rgba(32,32,32,0.08);
  padding: 16px;
  box-sizing: border-box;
  height: 100% !important;
  width: 252px;
  .active {
    // background-color: rgba(32, 32, 32, 0.08);
    color: $color-active !important;
  }
  ul li {
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    cursor: pointer;
    padding-right: 16px;
    transition: all .3s;
    &:hover {
      background-color: rgba(32, 32, 32, 0.04);
    }
    &:active {
      background-color: rgba(32, 32, 32, 0.08);
    }
  }
  .header1 {
    color: initial;
    font-size: 18px;
    font-weight: 500;
    padding-left: 16px;
  }
  .header2 {
    font-weight: 400;
    font-size: 14px;
    padding-left: 32px;
  }
  .header3 {
    font-weight: 400;
    font-size: 14px;
    color: rgba(32, 32, 32, 0.8);
    padding-left: 58px;
  }
  .header4 {
    font-weight: 400;
    font-size: 14px;
    color: rgba(32, 32, 32, 0.6);
    padding-left: 74px;
  }
  .header5 {
    font-weight: 400;
    font-size: 14px;
    color: rgba(32, 32, 32, 0.6);
    padding-left: 90px;
  }
}
</style>
